import React from 'react';
import DraggableModal from 'components/organisms/draggableModal';
import { useSmsCampaignQuestionsSelect } from 'infrastructure/hooks/select/use-sms-campaigns-question';
import { useFormik } from 'formik';
import BaseLoader from 'components/atoms/base-loader';
import { DateFormatter } from 'infrastructure/functions';

import OutcomeForm from '../../outcome-form/form';
import s from './styles.module.scss';

import type {
  IOutcomes,
  IOutcomesFormValues,
  ISmsCampaign,
} from 'infrastructure/interfaces';

interface IProps {
  opened: boolean;
  title: string;
  subTitle: string;
  outcomes: IOutcomes;
  patient: ISmsCampaign['patient'];
  campaignGuid: string;
  onClose: () => void;
}

const AnswersDraggableModal: React.FC<IProps> = (props) => {
  const { opened, title, subTitle, onClose, outcomes, campaignGuid, patient } =
    props;

  const { data, isLoading } = useSmsCampaignQuestionsSelect({
    campaignGuid,
    groupName: patient.outcomesQuestionGroup,
    language: patient.outcomesQuestionLanguage,
  });

  const values = outcomes.reduce<IOutcomesFormValues>((acc, item) => {
    return {
      ...acc,
      [item.question.guid]: {
        answers: item.answers.map((a) => a.guid),
        anyAnswer: item.anyAnswer ?? '',
        otherAnswerGuid:
          item.answers.find((a) => a.value === 'Other')?.guid ?? null,
      },
    };
  }, {});

  const formik = useFormik<IOutcomesFormValues>({
    initialValues: values,
    onSubmit: () => {},
    enableReinitialize: true,
  });

  return (
    <DraggableModal
      isOpen={opened}
      toggle={onClose}
      title={title}
      subTitle={subTitle}
      footer={false}
    >
      <div className={s.body}>
        {isLoading && (
          <BaseLoader loading height={20} width={20} className={s.loader} />
        )}
        {!isLoading && data && (
          <OutcomeForm
            data={data}
            formik={formik}
            readonly
            patientLanguage="en"
            patientName={title}
            patientDob={DateFormatter({ date: patient.birthDate })}
            patientEmail={patient.email}
          />
        )}
      </div>
    </DraggableModal>
  );
};

export default AnswersDraggableModal;
